/* import __COLOCATED_TEMPLATE__ from './workflow-connector-action.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();